function AddReadMore() {
  let carLmt = 248;
  // let readMoreTxt = "Mehr lesen";
  // let readLessTxt = " Weniger lesen";

  $(".addReadMore").each(function () {
    if ($(this).find(".firstSec").length) return;

    let allstr = $(this).html();

    if (allstr.length > carLmt) {
      let firstSet = allstr.substring(0, carLmt);

      let secdHalf = allstr.substring(carLmt, allstr.length);
      let strtoadd =
        firstSet +
        "<span class='SecSec'>" +
        secdHalf +
        "</span><span class='readMore' title='" +
        readMoreClick +
        "'> " +
        readMoreTxt +
        "</span><span class='readLess' title='" +
        readLessClick +
        "'> " +
        readLessTxt +
        "</span>";
      $(this).html(strtoadd);
    }
  });

  $(document).on("click", ".readMore,.readLess", function () {
    $(this)
      .closest(".addReadMore")
      .toggleClass("showlesscontent showmorecontent");
  });
}
function AddReadMoreCityDescStepsBlocks() {
  const BLOCKS_PER_CLICK = 8;
  const readMoreTxt = "weiterlesen";
  const readLessTxt = "Weniger lesen";

  $(".addReadMoreCityDesc").each(function () {
    const $container = $(this);

    // Schon verarbeitet?
    if ($container.data("alreadyInit")) return;
    $container.data("alreadyInit", true);

    // Kinder ermitteln
    const allChildren = $container.contents().toArray();
    // Daraus "Blöcke" bauen
    const blockArray = [];
    let currentBlock = [];

    const pushBlock = (blockEls) => {
      if (blockEls.length > 0) {
        const $div = $("<div class='rm-block'></div>");
        // hänge die Knoten an
        blockEls.forEach((el) => $div.append(el));
        blockArray.push($div);
      }
    };

    // Als Block-Trenner: p, div, hr, h*, ul, ol, table, etc.
    // Du kannst die Liste anpassen
    const blockTags = [
      "p",
      "div",
      "hr",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "ul",
      "ol",
      "table",
      "blockquote",
    ];

    allChildren.forEach((node) => {
      if (node.nodeType === 3) {
        // Text-Knoten
        if ($.trim(node.textContent) !== "") {
          currentBlock.push(node);
        }
      } else if (node.nodeType === 1) {
        const tagName = node.tagName.toLowerCase();
        if (blockTags.includes(tagName)) {
          // Beende bisherigen Block
          pushBlock(currentBlock);
          currentBlock = [];
          // Dieser Knoten wird eigener Block
          pushBlock([node]);
        } else {
          // Inline-Element (z.B. <span>)
          currentBlock.push(node);
        }
      }
    });
    // letzten Rest
    pushBlock(currentBlock);

    // Wenn nur x oder weniger Blöcke => kein Aufklappen nötig
    if (blockArray.length <= BLOCKS_PER_CLICK) return;

    // Container leeren
    $container.empty();
    // Index: wie viele Blöcke sind aktuell sichtbar
    $container.data("visibleCount", BLOCKS_PER_CLICK);

    // Rendering-Funktion
    const renderBlocks = () => {
      $container.empty();
      let visibleCount = $container.data("visibleCount");
      // Sicherheitscheck
      if (visibleCount < BLOCKS_PER_CLICK) visibleCount = BLOCKS_PER_CLICK;
      if (visibleCount > blockArray.length) visibleCount = blockArray.length;

      // Zeige die (visibleCount) Blöcke
      for (let i = 0; i < visibleCount; i++) {
        $container.append(blockArray[i]);
      }

      // Positioniere die Buttons am Ende des aktuell angezeigten Bereichs
      if (visibleCount < blockArray.length) {
        // Noch Blöcke übrig => weiterlesen-Button
        const $readMore = $(
          "<span class='cityDescReadMoreBlocks' style='cursor:pointer;text-decoration:underline;margin-left:6px;'></span>"
        ).text(readMoreTxt);
        $container.append($readMore);
      } else {
        // alles sichtbar => zeige Weniger-lesen-Button
        const $readLess = $(
          "<span class='cityDescReadLessBlocks' style='cursor:pointer;text-decoration:underline;margin-left:6px;'></span>"
        ).text(readLessTxt);
        // $container.append($readLess);
      }
    };

    // Erste Darstellung
    renderBlocks();

    // Event für "weiterlesen": +x Blöcke
    $(document).on("click", ".cityDescReadMoreBlocks", function () {
      const parent = $(this).closest(".addReadMoreCityDesc");
      let vc = parent.data("visibleCount");
      vc += BLOCKS_PER_CLICK;
      parent.data("visibleCount", vc);
      renderBlocks();
    });

    // Event für "Weniger lesen": zurück auf x Blöcke
    $(document).on("click", ".cityDescReadLessBlocks", function () {
      const parent = $(this).closest(".addReadMoreCityDesc");
      parent.data("visibleCount", BLOCKS_PER_CLICK);
      renderBlocks();
    });
  });
}
$(function () {
  AddReadMore();
  AddReadMoreCityDescStepsBlocks();
});
